import BaseComponent from 'scripts/BaseComponent.js';

export default class CartUpsells extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      tabBtn: '.js-upsellTabBtn',
      tabPanel: '.js-upsellTabPanel',
    };

    this.dom = {
      $component: component,
      $tabBtns: this.$getAll(this.refs.tabBtn),
      $tabPanels: this.$getAll(this.refs.tabPanel),
    };

    this.state = {};

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClickWithElement(dom.$tabBtns, this.tabClick);
  }

  tabClick(tabBtn) {
    const { dom } = this;
    const panelId = tabBtn.getAttribute('aria-controls');

    dom.$tabBtns.forEach((btn) => btn.setAttribute('aria-selected', false));
    tabBtn.setAttribute('aria-selected', true);

    dom.$tabPanels.forEach((btn) => btn.setAttribute('hidden', true));
    dom.$component.querySelector(`#${panelId}`).removeAttribute('hidden');
  }
}
